import React from 'react';
import { toJS } from 'mobx';
import InstructionVideoList from './InstructionVideoList';
import InstructionVideoListService from '../services/InstructionVideoListService';
import { observer } from 'mobx-react';

class InstructionVideoListContainer extends React.Component {
  componentDidMount() {
    InstructionVideoListService.handleLoad();
  }

  render() {
    return (
      <InstructionVideoList
        onDelete={InstructionVideoListService.handleRemove}
        items={toJS(InstructionVideoListService.items)}
        loading={InstructionVideoListService.fetch.fetching}
        pagination={InstructionVideoListService.pagination}
      />
    );
  }
}

export default observer(InstructionVideoListContainer);
